<template>
  <a :href="href" target="_blank" class="flex items-start space-x-4 text-primary mb-3">
    <span class="w-6 flex-shrink-0 flex justify-center text-lg leading-none mt-[0.2rem]">
      <slot name="icon">
        <UIcon :name="icon" />
      </slot>
    </span>

    <span>
      <span class="text-primary text-left">
        <slot name="label">
          <p class="text-left">
            {{ label }}
          </p>
        </slot>
      </span>
    </span>
  </a>
</template>

<script setup lang="ts">
const props = defineProps<{
  icon: string
  label: string
  href: string
}>()
</script>